"use strict";

var _ = require("underscore");

var QueryModel = require("@immanens-com/pv5js/search/models/query-model");
var StringUtil = require("@immanens-com/pv5js/common/utils/string-util");
var DateUtil = require("@immanens-com/pv5js/common/utils/date-util");

var debug = require("debug")("models:ArticleQueryModel");    //https://github.com/visionmedia/debug

/**
 * ArticleQueryModel : recherche dans les articles retronews si du texte est rempli
 * ou dans l'index document sinon
 */
module.exports = QueryModel.extend({

    defaults: _.defaults({
        someTerms: null,
        allTerms: null,
        noneTerms: null,
        phrase: null,
        exact: false,
        highlight: true,
        highlightPosition: false,
        highlightFragments: 4,
        highlightFragmentsSize: 30,
        cover: false,
        query: "article-cc",
        sort: "score",
        documentId: 0,
        publicationId: 0,
        publication: null,
        publishedStart: null,
        publishedEnd: null,
        publishedBounds: "from",
        publishedDay: 0,
        publishedMonth: 0,
        indexedStart: null,
        indexedEnd: null,
        indexedBounds: "from",
        pageNumber: 0,               // page number
        label: null,                 // page label
        tfThemes: [],                // filtre page themes
        tfThemesOr: [],              // filtre page themes
        excludeThemes:false,
        tfPublications: [],          // filtre publication title (and)
        tfPublicationsOr: [],        // filter publication title (or)
        excludePublications:false,
        tfPersons: [],               // filtre page persons
        tfOrganizations: [],         // filtre page organizations
        tfGeolocs: [],               // filtre page location
        tfEvents: [],                // filtre page events
        tfWikitags: [],              // filtre page events
        tfHistoPeriods: [],
        tfTypes: [],                 // filtre publication type
        tfTypesOr: [],               // filtre publication type
        excludeTypes: false,
        tfPeriodicities: [],         // filtre publication periodicity
        tfPeriodicitiesOr: [],       // filtre publication periodicity
        excludePeriodicities:false,
        tfPublicationGeotagsOr: [],  // filtre publication location
        excludeGeotags:false,
        tfLangsOr: [],
        excludeLangs:false,
        superPublishedRange: null,
        useAgg: true,
        useAggPublishedRanges: true,
        access: "public",
        slop: 0,
        aggSizes: {
            histoPeriods: 20,
            persons: 5,
            organizations: 5,
            geolocs: 5,
            events: 5,
            types: 5,
            periodicities: 5,
            publications: 5,
            wikitags: 5,
            themes: 20,
            documents: 0
        },
        aggPublishedHistogram: null,
        aggNbDocuments: false,
        aggNbPublications: false
    }, QueryModel.prototype.defaults),

    whiteList: [
        "someTerms",
        "allTerms",
        "noneTerms",
        "phrase",
        "exact",
        "cover",
        "sort",
        "pageNumber",
        "publishedStart",
        "publishedEnd",
        "publishedBounds",
        "indexedStart",
        "indexedEnd",
        "indexedBounds",
        "publishedDay",
        "publishedMonth",
        "tfThemesOr",
        "tfThemes",
        "excludeThemes",
        "tfPersons",
        "tfOrganizations",
        "tfGeolocs",
        "tfEvents",
        "tfWikitags",
        "tfHistoPeriods",
        "tfTypes",
        "tfTypesOr",
        "excludeTypes",
        "tfPeriodicities",
        "tfPeriodicitiesOr",
        "excludePeriodicities",
        "tfPublications",
        "tfPublicationsOr",
        "excludePublications",
        "tfPublicationGeotagsOr",
        "excludeGeotags",
        "tfLangsOr",
        "excludeLangs",
        "slop"
    ],

    minPublishedDate: null,
    maxPublishedDate: null,

    initialize: function (/*attributes, options*/) {
        QueryModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
    },

    // called by super class
    buildQuery: function () {
        var T = this;

        var agg_sizes = T.get("aggSizes");

        var q = {
            access: T.get("access"),
            someTerms: T.get("someTerms"),
            allTerms: T.get("allTerms"),
            noneTerms: T.get("noneTerms"),
            phrase: T.get("phrase"),
            exact: T.get("exact"),
            cover: T.get("cover"),
            highlight: T.get("highlight"),
            highlightPosition: T.get("highlightPosition"),
            highlightFragments: T.get("highlightFragments"),
            highlightFragmentsSize: T.get("highlightFragmentsSize"),
            sort: T.get("sort"),
            useAgg: T.get("useAgg"),
            aggSizes: agg_sizes,
            pageNumber: T.get("pageNumber"),
            publicationId: T.get("publicationId"),
            documentId: T.get("documentId"),
            publishedStart: T.get("publishedStart"),
            publishedEnd: T.get("publishedEnd"),
            indexedStart: T.get("indexedStart"),
            indexedEnd: T.get("indexedEnd"),
            publishedMonth: T.get("publishedMonth"),
            publishedDay: T.get("publishedDay"),
            tfThemes: T.get("tfThemes"),
            tfThemesOr: T.get("tfThemesOr"),
            tfEvents: T.get("tfEvents"),
            tfWikitags: T.get("tfWikitags"),
            tfHistoPeriods: T.get("tfHistoPeriods"),
            tfPersons: T.get("tfPersons"),
            tfOrganizations: T.get("tfOrganizations"),
            tfTypes: T.get("tfTypes"),
            tfTypesOr: T.get("tfTypesOr"),
            tfPeriodicities: T.get("tfPeriodicities"),
            tfPeriodicitiesOr: T.get("tfPeriodicitiesOr"),
            tfGeolocs: T.get("tfGeolocs"),
            tfPublications: T.get("tfPublications"),
            tfPublicationsOr: T.get("tfPublicationsOr"),
            tfPublicationGeotagsOr: T.get("tfPublicationGeotagsOr"),
            tfLangsOr: T.get("tfLangsOr"),
            aggPublishedHistogram: T.get("aggPublishedHistogram"),
            aggNbDocuments: T.get("aggNbDocuments"),
            aggNbPublications: T.get("aggNbPublications"),
            slop:T.get("slop")
        };

        var published_bounds = T.get("publishedBounds");
        if (q.publishedStart && !q.publishedEnd) {
            q.publishedEnd = q.publishedStart;
        }
        if (!q.publishedStart && q.publishedEnd) {
            q.publishedStart = q.publishedEnd;
        }
        if (q.publishedStart) {
            if (published_bounds == "on") {
                q.publishedEnd = q.publishedStart;
            }
            else if (published_bounds == "before") {
                q.publishedEnd = q.publishedStart;
                q.publishedStart = T.minPublishedDate;
            }
            else if (published_bounds == "after") {
                q.publishedEnd = T.maxPublishedDate;
            }
        }

        var indexed_bounds = T.get("indexedBounds");
        if (q.indexedStart && !q.indexedEnd) {
            q.indexedEnd = q.indexedStart;
        }
        if (!q.indexedStart && q.indexedEnd) {
            q.indexedStart = q.indexedEnd;
        }
        if (q.indexedStart) {
            if (indexed_bounds == "on") {
                q.indexedEnd = q.indexedStart;
            }
            else if (indexed_bounds == "before") {
                q.indexedEnd = q.indexedStart;
                q.indexedStart = "2015-01-01";
            }
            else if (indexed_bounds == "after") {
                q.indexedEnd = new Date().toISOString().substr(0, 10);
            }
        }

        if(T.get("excludeTypes")){
            q.tfTypesNot=q.tfTypesOr;
            delete(q.tfTypesOr);
        }

        if(T.get("excludePeriodicities")){
            q.tfPeriodicitiesNot=q.tfPeriodicitiesOr;
            delete(q.tfPeriodicitiesOr);
        }

        if(T.get("excludePublications")){
            q.tfPublicationsNot=q.tfPublicationsOr;
            delete(q.tfPublicationsOr);
        }

        if(T.get("excludeLangs")){
            q.tfLangsNot=q.tfLangsOr;
            delete(q.tfLangsOr);
        }

        if(T.get("excludeThemes")){
            q.tfThemesNot=q.tfThemesOr;
            delete(q.tfThemesOr);
        }

        if (q.tfPublicationGeotagsOr) {
            // transformation en city/department/region/contry
            var countries = [];
            var cities = [];
            var departments = [];
            var regions = [];

            _.each(q.tfPublicationGeotagsOr, function (geotag) {
                var prefix = geotag.substr(0, 2);
                var value = geotag.substr(3);

                if (prefix == "co") {
                    countries.push(value);
                } else if (prefix == "ci") {
                    cities.push(value);
                }
                else if (prefix == "de") {
                    departments.push(value);
                }
                else if (prefix == "re") {
                    regions.push(value);
                }
            });

            var exclude = T.get("excludeGeotags");
            if (cities.length) {
                if(exclude){
                    q.tfPublicationCitiesNot = cities;
                }
                else{
                    q.tfPublicationCitiesOr = cities;
                }
            }
            if (countries.length) {
                if(exclude){
                    q.tfPublicationCountriesNot = countries;
                }
                else{
                    q.tfPublicationCountriesOr = countries;
                }
            }
            if (departments.length) {
                if(exclude){
                    q.tfPublicationDepartmentsNot = departments;
                }
                else{
                    q.tfPublicationDepartmentsOr = departments;
                }
            }
            if (regions.length) {
                if(exclude){
                    q.tfPublicationRegionsNot = regions;
                }
                else{
                    q.tfPublicationRegionsOr = regions;
                }
            }

            delete (q.tfPublicationGeotagsOr);

            q.useGeotag = true;
        }

        if (!q.someTerms && !q.allTerms && !q.noneTerms && !q.phrase) {
            // il n'y a pas de termes de spécifiés, on recherche dans les documents pour afficher des couvertures
            T.set("query", "document-cc");
            if (q.sort == "score") {
                q.sort = "date-asc";
            }
            q.highlight = false;
        }
        else {
            T.set("query", "article-cc");
        }

        if (q.cover) {
            q.isFirstPage = true;
        }

        // rechercher si un des tableaux en tf contient quelque chose, si oui on doit filtrer
        _.every(_.keys(q), function (key) {
            if (key.substr(0, 2) == "tf") {
                if (q[key].length) {
                    q.useFilter = true;
                    return false;
                }
            }
            return true;
        });

        if (q.tfThemes.length) {
            q.aggThemesNested = true;
        }

        if (T.get("useAggPublishedRanges")) {
            if (!q.publishedStart && !q.publishedEnd) {
                q.aggPublishedRanges = T._computeRanges(T.minPublishedDate, T.maxPublishedDate);
                T.set("superPublishedRange", null);
            }
            else {
                q.aggPublishedRanges = T._computeRanges(q.publishedStart, q.publishedEnd);
                T.set("superPublishedRange", T._computeSuperDateRange(q.publishedStart, q.publishedEnd));
            }
        }

        return q;
    },

    _computeRanges: function (date_start_str, date_end_str) {
        // 50y, 10y, 1y, 1M, 1w, 1d, (behaviour taken from : http://www.britishnewspaperarchive.co.uk/search/results?basicsearch=%2bparis)
        // attention avec les aggregations date range le "from" est compris mais pas le "to",
        // donc tous les ranges ont un jour de plus qu'il faudra retrancher au moment de faire
        // la recherche car dans la recherche le "start" et le "end" sont inclus
        var T = this,
            ret = [],
            date_start = DateUtil.dateFactory(date_start_str),
            date_end = DateUtil.dateFactory(date_end_str),
            year_diff = date_end.getUTCFullYear() - date_start.getUTCFullYear();

        T._formatPublishedRangeUnit = "year";
        T._formatPublishedRangeValue = 1;

        if (year_diff > 50) {
            // more than 50 years
            ret = DateUtil.splitYears(date_start_str, date_end_str, 50);
            T._formatPublishedRangeValue = 50;
        }
        else if (year_diff > 10) {
            // between 49 and 10 years
            ret = DateUtil.splitYears(date_start_str, date_end_str, 10);
            T._formatPublishedRangeValue = 10;
        }
        else if (year_diff > 0) {
            // between 2 and 10 years
            ret = DateUtil.splitYears(date_start_str, date_end_str, 1);
        }
        else {
            //same year
            var month_diff = date_end.getUTCMonth() - date_start.getUTCMonth();
            if (month_diff > 0) {
                ret = DateUtil.splitMonths(date_start_str, date_end_str, 1);
                T._formatPublishedRangeUnit = "month";
            }
            else {
                // same year and same month
                var day_diff = date_end.getUTCDate() - date_start.getUTCDate();
                if (day_diff > 7) {
                    ret = DateUtil.splitWeeks(date_start_str, date_end_str, 1);
                    T._formatPublishedRangeUnit = "week";
                }
                else {
                    ret = DateUtil.splitDays(date_start_str, date_end_str, 1);
                    T._formatPublishedRangeUnit = "day";
                }
            }
        }

        return ret;
    },

    _computeSuperDateRange: function (date_start_str, date_end_str) {
        var T = this,
            ret = {
                from: null,
                to: null,
                label: null
            },
            date_start = DateUtil.dateFactory(date_start_str),
            date_end = DateUtil.dateFactory(date_end_str);

        switch (T._formatPublishedRangeUnit) {
            case "year":
                // algo : on recherche si les dates sont comprises dans une cinquantaine ?
                // sinon on utilise toutes les dates (si ce sont des dates à cheval par exemple)
                if (T._formatPublishedRangeValue == 1) {
                    var y_50_1 = Math.floor(date_start.getUTCFullYear() / 50) * 50;
                    var y_50_2 = Math.ceil(date_end.getUTCFullYear() / 50) * 50;
                    if (y_50_2 - y_50_1 <= 50) {
                        ret.from = y_50_1 + "-1-1";
                        ret.to = (y_50_2 - 1) + "-12-31";
                    }
                }
                if (T._formatPublishedRangeValue != 50) {
                    ret.label = date_start.getUTCFullYear() + "-" + date_end.getUTCFullYear();
                }
                break;
            case "month":
                ret.label = date_start.getUTCFullYear();
                var ym1 = Math.floor(date_start.getUTCFullYear() / 10) * 10;
                ret.from = ym1 + "-1-1";
                ret.to = (ym1 + 10 - 1) + "-12-31"; // 10 years
                break;
            case "week":
                ret.label = STR["month_" + (date_start.getUTCMonth() + 1)] + " " + date_start.getUTCFullYear();
                var yw1 = Math.floor(date_start.getUTCFullYear());
                ret.from = yw1 + "-1-1";
                ret.to = yw1 + "-12-31"; // 1 year
                break;
            case "day":
                ret.label = STR["month_" + (date_start.getUTCMonth() + 1)] + " " + date_start.getUTCFullYear();
                var yd1 = date_start.getUTCFullYear();
                ret.from = yd1 + "-" + (date_start.getUTCMonth() + 1) + "-1";
                var lastDay = new Date(date_start);
                lastDay.setUTCMonth(lastDay.getUTCMonth() + 1);
                lastDay.setUTCDate(0);
                ret.to = yd1 + "-" + (lastDay.getUTCMonth() + 1) + "-" + lastDay.getUTCDate(); // month
                break;
        }

        return ret;
    },

    fetchFrom: function (index, options) {
        var T = this;
        if (T.fetching) {
            return;
        }
        var final_options = options || {};
        return T.fetch({
            "from": index,
            "size": T.get("pageSize")
        }, final_options);
    },

    parse: function (response/*, xhr*/) {
        var T = this;
        // correct aggregation labels in date range
        if (response.aggregations && response.aggregations.publishedRanges && response.aggregations.publishedRanges.buckets) {
            response.aggregations.publishedRanges.buckets.forEach(function (bucket) {
                // on enlève 1 jour à la date "to" pour respecter le formalisme de recherche (to et from inclus)
                var to = DateUtil.dateFactory(bucket.to_as_string);
                to.setUTCDate(to.getUTCDate() - 1);
                bucket.to_as_string = to.getUTCFullYear() + "-" + StringUtil.pad(to.getUTCMonth() + 1, 2) + "-" + StringUtil.pad(to.getUTCDate(), 2);
                bucket.from_to_as_string = T._labelPublishedDateRange(bucket.from_as_string, bucket.to_as_string);
            });

        }
        return T.constructor.__super__.parse.apply(T, arguments);
    },

    _labelPublishedDateRange: function (date_start_str, date_end_str) {
        var T = this,
            ret,
            date_start = DateUtil.dateFactory(date_start_str),
            date_end = DateUtil.dateFactory(date_end_str);
        switch (T._formatPublishedRangeUnit) {
            case "year":
                if (date_start.getUTCFullYear() == date_end.getUTCFullYear()) {
                    ret = date_start.getUTCFullYear();
                }
                else {
                    ret = date_start.getUTCFullYear() + "-" + date_end.getUTCFullYear();
                }
                break;
            case "month":
                ret = STR["month_" + (date_start.getUTCMonth() + 1)];
                break;
            case "week":
                ret = date_start.getUTCDate() + "-" + date_end.getUTCDate();
                break;
            case "day":
                ret = date_start.getUTCDate();
                break;
        }
        return ret;
    },

    /**
     * Check if query contain highlitable terms
     * @return {Boolean}
     */
    hasTerms: function () {
        var T = this,
            ret = false;
        if (T.get("allTerms") || T.get("someTerms") || T.get("phrase")) {
            ret = true;
        }
        return ret;
    },

    /**
     * Returns applied filters
     * @return {Object}
     */
    appliedFilters: function () {
        var T = this,
            filters = {};

        _.each(T.keys(), function (key) {
            if (key.substr(0, 2) == "tf") {
                filters[key] = T.get(key);
            }
        });

        filters.tfPublishedRanges = {
            start: T.get("publishedStart"),
            end: T.get("publishedEnd")
        };

        return filters;
    },

    reset: function () {
        this.set(_.pick(this.defaults, this.whiteList));
    },

    resetFilters: function () {
        this.set({
            tfThemes: [],                // filtre page themes
            tfPublications: [],          // filtre publication title (and)
            tfPersons: [],               // filtre page persons
            tfOrganizations: [],         // filtre page organizations
            tfGeolocs: [],               // filtre page location
            tfEvents: [],                // filtre page events
            tfWikitags: [],              // filtre page events
            tfHistoPeriods: [],              // filtre page events
            tfTypes: [],                 // filtre publication type
            tfPeriodicities: [],         // filtre publication periodicity
            publishedStart: null,
            publishedEnd: null,
        });
    }

});
